query GetGrants(
  $page: Int
  $limit: Int
  $sortBy: String
  $senderLegalEntityIds: [ID!]
  $statuses: [GrantCaseRecordStatusEnum!]
  $filterGroup: GrantFilterGroupInput
) {
  grants(
    page: $page
    limit: $limit
    sortBy: $sortBy
    senderLegalEntityIds: $senderLegalEntityIds
    statuses: $statuses
    filterGroup: $filterGroup
  ) {
    collection {
      id
      description
      caseType {
        id
        name
      }
      salesforceId
      recipientFundAccount {
        id
        currency
        fund {
          id
          name
        }
      }
      senderFundAccount {
        id
        currency
        fund {
          id
          name
        }
      }
      contact {
        id
        name
      }
      senderContact {
        id
        name
      }
      legallyDonatingEntity {
        id
        name
      }
      caseStage {
        id
        name
        includeInBalances
      }
      senderCharity {
        id
        name
      }
      recipientCharity {
        id
        name
      }
      endUserCharity {
        id
        name
      }
      recipientCompany {
        id
        name
      }
      senderCompany {
        id
        name
      }
      submittedBy {
        id
        name
      }
      owner {
        id
        name
      }
      lastModifiedBy {
        id
        name
      }
      createdBy {
        id
        name
      }
      senderAmount {
        minorUnit
        currency
      }
      recipientAmountForRollUps {
        minorUnit
        currency
      }
      fxAtTimeOfTransaction
      transactionDate
      notes
      highImpactAtTimeOfDeployment
      createdAt
      updatedAt
      status
      caseNumber
      displayName
      senderType
      senderName
      recipientType
      recipientName
      hasSyncError
      syncErrorMessage
      sageJournalEntries {
        id
        description
        sageGiftAccount {
          id
          sageId
        }
      }
      grantCaseRecord {
        readyForRelease
        disbursement {
          status
        }
        grantRiskLevel {
          tier
          reasons
        }
        status
        usDueDiligence {
          id
          status
          suggestedStatus {
            status
            reasons
          }
        }
        complianceChecks {
          id
          status
          name
        }
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
